import { useLayoutEffect } from "react";
import { applyArticleScreenWidth, useArticleWidthStore } from "./ArticleWidthStore";

// A CSS variable instead of React state: a width change must not re-render the article.
const useArticleScreenWidthVar = () => {
	useLayoutEffect(() => {
		applyArticleScreenWidth(useArticleWidthStore.getState().width);
		return useArticleWidthStore.subscribe((state) => applyArticleScreenWidth(state.width));
	}, []);
};

export default useArticleScreenWidthVar;
